import { render, staticRenderFns } from "./confirmAllocation.vue?vue&type=template&id=0596c5d4&scoped=true"
import script from "./confirmAllocation.vue?vue&type=script&lang=js"
export * from "./confirmAllocation.vue?vue&type=script&lang=js"
import style0 from "./confirmAllocation.vue?vue&type=style&index=0&id=0596c5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0596c5d4",
  null
  
)

export default component.exports